import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { PreviewContext } from '../context/preview-context';
import { PreviewCloseButton } from '../base-components/preview-close-button';
import { Styled } from './preview-content.styles';
import { PreviewFooter, PreviewActor } from '.';
export const PreviewContent = ({ description, cachedImageUrl, sourceActor, sourceDomain, title, }) => {
    const { imageMaxHeight, imageUrl, className, onClose } = React.useContext(PreviewContext);
    const image = imageUrl || cachedImageUrl || '';
    return (_jsxs(Styled.Card, { noPadding: true, className, "data-testid": "link-preview-content", children: [_jsx(PreviewActor, { ...(sourceActor && sourceActor), actorComment: (!title && description) || undefined, hasLinkImage: !!image }), image && (_jsx(Styled.Image, { src: image, "$imageMaxHeight": imageMaxHeight, "data-testid": "link-preview-image" })), title && sourceDomain && (_jsx(PreviewFooter, { description,
                sourceDomain,
                title,
                hasActorAndNoImage: !image && !!sourceActor })), onClose && _jsx(PreviewCloseButton, { onClose })] }));
};
//# sourceMappingURL=preview-content.js.map